import { useMutation, useQueryClient } from '@tanstack/react-query'
import { closeOrdoclic } from '../../../data/ordoclic/closeOrdoclic'
import { UserFriendlyError } from '../../../model/Error'
import { patientHealthDataKeys } from '../patientHealthData/patientHealthData.keys'
import { patientInformationsKeys } from '../patientInformations/patientInformations.keys'
import { patientsKeys } from '../patients/patients.keys'

interface CloseOrdoclicMutateVariables {
  ordoclicPatientIds: string[]
}

export const useCloseOrdoclic = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ ordoclicPatientIds }: CloseOrdoclicMutateVariables) => {
      const { ok, data } = await closeOrdoclic(ordoclicPatientIds)

      if (!data || !ok) {
        throw new UserFriendlyError(
          'error',
          "Une erreur s'est produite",
          "Impossible de synchroniser les données provenant de l'e-prescription",
        )
      }

      return data
    },
    onSuccess: (patientIds: number[]) => {
      patientIds.forEach((patientId: number) => {
        queryClient.invalidateQueries({ queryKey: patientHealthDataKeys.detail(patientId) })
        queryClient.invalidateQueries({ queryKey: patientsKeys.detail(patientId) })
        queryClient.invalidateQueries({ queryKey: patientInformationsKeys.list(patientId) })
      })
    },
  })
}
